import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StorageKeysService } from 'app/shared/services/storage-keys.service';
@Injectable({ providedIn: 'root' })
export class AuthService {
    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _storageKeysService: StorageKeysService) {}

    // /**
    //  * Check the authentication status
    //  */
    check() {
        return this.isAuthenticated();
    }
    login(auth) {
        return this._httpClient.post(environment.apiUrl + '/auth/login', auth).toPromise();
    }

    logout() {
        // this._api.user.next(null);
        let user = JSON.parse(localStorage.getItem(this._storageKeysService.userData));

        const versao = localStorage.getItem(this._storageKeysService.versao);
        const scheme = localStorage.getItem(this._storageKeysService.scheme);
        const construction = localStorage.getItem('construction');
        // if (user.ambiente_id != environment.ambiente_id){
        //     localStorage.clear();
        //     location.reload();
        //     localStorage.clear();
        // }
        localStorage.clear();
        if (versao) {
            localStorage.setItem(this._storageKeysService.versao, versao);
        }
        if (scheme) {
            localStorage.setItem(this._storageKeysService.scheme, scheme);
        }
        location.reload();
        // this._router.navigate(['compact/account/login']);
    }
    logoutNotReload() {
        // this._api.user.next(null);
        let user = JSON.parse(localStorage.getItem(this._storageKeysService.userData));

        const versao = localStorage.getItem(this._storageKeysService.versao);
        const scheme = localStorage.getItem(this._storageKeysService.scheme);
        const construction = localStorage.getItem('construction');
        // if (user.ambiente_id != environment.ambiente_id){
        //     localStorage.clear();
        //     location.reload();
        //     localStorage.clear();
        // }
        localStorage.clear();
        if (versao) {
            localStorage.setItem(this._storageKeysService.versao, versao);
        }
        if (scheme) {
            localStorage.setItem(this._storageKeysService.scheme, scheme);
        }
        // this._router.navigate(['compact/account/login']);
    }

    forgotPassword(email: string): Observable<any> {
        return this._httpClient.post(environment.apiUrl + '/auth/forgot-password', { email });
    }

    resetPassword(token: string, senha: string): Observable<any> {
        return this._httpClient.post(environment.apiUrl + '/auth/reset-password', { token, password: senha });
    }

    getToken(token: string): Observable<any> {
        return this._httpClient.get(environment.apiUrl + '/auth/validate-reset-token/' + token);
    }

    get token() {
        return localStorage.getItem(this._storageKeysService.token);
    }
    get tokenRefresh() {
        return localStorage.getItem(this._storageKeysService.tokenRefresh);
    }
    get rememberMe() {
        return localStorage.getItem(this._storageKeysService.rememberMe);
    }

    isAuthenticated() {
        return Boolean(this.token);
    }

    set token(token: string) {
        localStorage.setItem(this._storageKeysService.token, token);
    }
    set tokenRefresh(token) {
        localStorage.setItem(this._storageKeysService.tokenRefresh, token);
    }
    set rememberMe(value: string) {
        localStorage.setItem(this._storageKeysService.rememberMe, value);
    }
}
